import React from 'react'
import rsa from "../assets/rsa.png";

function Home() {
  return (

   <div className='dark:bg-[#0a192f]'>

    <p className='text-center dark:text-gray-400/75 tracking-widest text-5xl lg:text-8xl m-10 ' >RSA ALGORITHM</p>
   

    <p className='container mx-5 text-center font-mono text-2xl  dark:text-teal-400 break-words'>
     <ul className="list-disc text-left m-20 ">
      <li className='my-8'>The RSA algorithm (Rivest-Shamir-Adleman) is the basis of a cryptosystem</li>
      <li className='my-8'>a suite of cryptographic algorithms that are used for specific security services or purposes</li>
      <li className='my-8'>which enables public key encryption and is widely used to secure sensitive data, particularly when it is being sent over an insecure network such as the internet</li>
       </ul>   
      </p>
      <div className='flex justify-center items-center'>
      <img className='w-50 ' src={rsa} alt="RSA_ALGO" />
      </div>
      

   </div>
  )

}

export default Home;